import React, {Component, PropTypes} from 'react';
import {connectReduxForm} from 'redux-form';
import {validateEditProfile} from 'utils/validateNormalize';
import {
  GetFirstName,
  GetLastName,
  GetPhone,
  GetCity,
  GetStatesOrProvince,
  GetCountry,
  GetSchool,
  GetOptIn
} from "./registrationComponents";
import Regionalization from "../../services/regionalization"
import ChangeEmailModal from "./changeEmailModal";
import ChangePasswordModal from "./changePasswordModal";
import "./registerEditProfileForm.scss";

@connectReduxForm({
  form: 'registerEditProfile',
  fields: [
    'alert',
    'firstName',
    'lastName',
    'phone',
    'cityOrMunicipality',
    'stateOrProvince',
    'country',
    'school',
    'directPromotionOptIn',
    'gettingStartedOptIn',
    'marketingOptIn'
  ],
  validate: validateEditProfile
})
export default class EditProfileForm extends Component {
  static propTypes = {
    fields: PropTypes.shape({
      alert: PropTypes.object.isRequired,
      firstName: PropTypes.object.isRequired,
      lastName: PropTypes.object.isRequired,
      phone: PropTypes.object,
      cityOrMunicipality: PropTypes.object.isRequired,
      stateOrProvince: PropTypes.object.isRequired,
      country: PropTypes.object.isRequired,
      school: PropTypes.object.isRequired,
      gettingStartedOptIn: PropTypes.object.isRequired,
      directPromotionOptIn: PropTypes.object.isRequired,
      marketingOptIn: PropTypes.object.isRequired
    }).isRequired,
    submitting: PropTypes.bool.isRequired,
    userId: PropTypes.string,
    email: PropTypes.string,
    resetChangeEmailForm: PropTypes.func,
    resetChangePasswordForm: PropTypes.func,
    changeEmail: PropTypes.func,
    changePassword: PropTypes.func,
    completeRegistration: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      showChangeEmailModal: false,
      showChangePasswordModal: false,
      personRegistrationFormData: [],
      personalRegistrationFormMode: true,
      schoolRegistrationFormData: [],
      isFirstPage: !props.completeRegistration,
      isSubmitting: false
    };
    this.countries = Regionalization.getCountries();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fields.country.value !== this.props.fields.country.value) {
      const defaultValue = Regionalization.hasStatesOrProvinces(nextProps.fields.country.value) ? '' : 'Other';
      this.props.fields.stateOrProvince.onChange(defaultValue);
    }
  }

  openChangeEmail (evt) {
    const { resetChangeEmailForm } = this.props;
    resetChangeEmailForm();
    this.setState({ showChangeEmailModal: true });
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  closeChangeEmail () {
    this.setState({ showChangeEmailModal: false });
  }

  handleChangeEmailSubmit (data) {
    const { email: newEmail, password } = data;
    const { changeEmail, userId, email: oldEmail } = this.props;
    return changeEmail({
      userId,
      oldEmail,
      newEmail,
      password
    }).then(() => {
      this.closeChangeEmail();
    });
  }

  openChangePassword (evt) {
    const { resetChangePasswordForm } = this.props;
    resetChangePasswordForm();
    this.setState({ showChangePasswordModal: true });
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  closeChangePassword () {
    this.setState({ showChangePasswordModal: false });
  }

  handleChangePasswordSubmit (data) {
    const { changePassword, email } = this.props;
    const { oldPassword, newPassword } = data;
    return changePassword({
      email,
      oldPassword,
      newPassword
    }).then(() => {
      this.closeChangePassword();
    });
  }

  handleSubmit(evt) {
    this.setState(prevState => ({
      isSubmitting: !prevState.isSubmitting
    }));
    this.props.handleSubmit(evt);
  }

  render() {
    const {
      fields: {
        alert,
        firstName,
        lastName,
        phone,
        cityOrMunicipality,
        stateOrProvince,
        country,
        school,
        directPromotionOptIn,
        gettingStartedOptIn,
        marketingOptIn
      },
      email,
      invalid
    } = this.props;

    const statesOrProvinces = Regionalization.getStatesOrProvinces(country.value);
    if (statesOrProvinces.length === 1) {
      stateOrProvince.disabled = true;
    }

    return (
      <div className="col-lg-8 col-md-8 col-sm-6">
        <div>
          <h4 className="adminPageTitle">Edit Profile</h4>
          {alert.error &&
          <div className="form-group">
            <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}></div>
          </div>
          }
          <h3>Personal</h3>
          <hr/>
          <GetFirstName firstName={firstName}/>
          <GetLastName lastName={lastName}/>
          <GetPhone phone={phone} />
          <h3>Account</h3>
          <hr/>
          <div className="form-group">
            <label htmlFor="txtEmail" className="control-label">
              Email
            </label>
            <div>
              {email}&nbsp;
              <button className="btn btn-default btn-sm" onClick={::this.openChangeEmail}>Change email</button>
            </div>
            <ChangeEmailModal showModal={this.state.showChangeEmailModal}
                              closeModal={::this.closeChangeEmail}
                              onSubmit={::this.handleChangeEmailSubmit} />
          </div>
          <div className="form-group">
            <label htmlFor="txtPassword" className="control-label">
              Password
            </label>
            <div>
              <button className="btn btn-default btn-sm" onClick={::this.openChangePassword}>Change password</button>
            </div>
            <ChangePasswordModal showModal={this.state.showChangePasswordModal}
                                 closeModal={::this.closeChangePassword}
                                 onSubmit={::this.handleChangePasswordSubmit} />
          </div>
          <h3>School</h3>
          <hr />
          <GetCountry country={country} countries={this.countries} />
          <GetStatesOrProvince stateOrProvince={stateOrProvince} statesOrProvinces={statesOrProvinces} />
          <GetCity cityOrMunicipality={cityOrMunicipality} />
          <GetSchool school={school} />
          <h3>Communications</h3>
          <hr/>
          <GetOptIn label="Help to get started from a real human (1-4 messages per month)" optIn={ gettingStartedOptIn }/>
          <GetOptIn label="Information about free programs in my area (2-4 messages per year)" optIn={ directPromotionOptIn }/>
          <GetOptIn label="Newsletter with exclusive content and product news (4-6 messages per year)" optIn={ marketingOptIn }/>
          <button
            onClick={::this.handleSubmit}
            disabled={invalid}
            className="btn btn-lg btn-primary spinnerButton"
          >
            Submit
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/editProfileForm.jsx